import React from 'react';
import Logo from '../assets/img/logo.png';

const Links = () => {
    return (
        <div className="container">
            <main>
                <div className="main-div">
                    <div className="header-div">
                        <img className="logo" src={Logo} alt="logo The Worky" />
                        <p className="arroba">@theworky</p>
                    </div>
                    <div className="buttons">
                        <a href="https://www.theworky.com/" target="_blank" rel="noopener noreferrer">Nosso Site</a>
                        <a href="https://www.theworky.com/cadastro?modal=budget" target="_blank" rel="noopener noreferrer">Fazer Orçamento - Empresas</a>
                        <a href="https://www.theworky.com/cadastro?modal=resume" target="_blank" rel="noopener noreferrer">Enviar Currículo - Candidatos</a>
                        <a href="https://api.whatsapp.com/send?phone=5521983372459" target="_blank" rel="noopener noreferrer">WhatsApp</a>
                        <a href="https://www.theworky.com/servicos" target="_blank" rel="noopener noreferrer">Serviços</a>
                        <a href="https://www.theworky.com/sobre" target="_blank" rel="noopener noreferrer">Sobre</a>
                    </div>
                    <div className="bottom-div">
                        <p>The Worky Consultoria e Terceirização Copyright © 2022</p>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default Links;